(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    

  const container = document.querySelector('.article-content .prose');
  const h2Elements = container.querySelectorAll('h2');

  h2Elements.forEach((h2, index) => {
    const id = `topic-${index < 9 ? '0' : ''}${index + 1}`;
    h2.setAttribute('id', id);
  });

  } catch(e) { console.error(e); }
})();
})();
